/**
 * Browser-only token storage helper for `apps/web-console`.
 *
 * Exposes the same `getScopedStorageItem` / `setScopedStorageItem` /
 * `removeScopedStorageItem` API as the legacy `office-storage.helper.ts`
 * in `kirigami-analysis`, but without the Office partition-key logic.
 * Platform boundary: Office.js concerns belong to `libs/platform/office`
 * (future) and `apps/word-addin` — never in `libs/platform/browser`.
 *
 * Word add-in will later provide its own `@kirigami/platform/office`
 * export with the same signatures, allowing the auth services to remain
 * host-agnostic through a DI seam.
 */

function getLocalStorage(): Storage | null {
  if (typeof window === 'undefined') {
    return null;
  }
  try {
    return window.localStorage ?? null;
  } catch {
    return null;
  }
}

export function getScopedStorageItem(key: string): string | null {
  return getLocalStorage()?.getItem(key) ?? null;
}

export function setScopedStorageItem(key: string, value: string): void {
  getLocalStorage()?.setItem(key, value);
}

export function removeScopedStorageItem(key: string): void {
  getLocalStorage()?.removeItem(key);
}
